module.exports = __webpack_public_path__ + "static/media/Portrait-10232.39d8f4e5.jpg";